import { useCallback, useEffect, useState } from 'react';

export const OTP_RESEND_COOLDOWN_SECONDS = 30;

const useOtpResendCooldown = (seconds = OTP_RESEND_COOLDOWN_SECONDS) => {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    if (remainingSeconds <= 0) return undefined;
    const timer = window.setTimeout(() => {
      setRemainingSeconds((current) => Math.max(0, current - 1));
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [remainingSeconds]);

  const start = useCallback(() => {
    setRemainingSeconds(seconds);
  }, [seconds]);

  const reset = useCallback(() => {
    setRemainingSeconds(0);
  }, []);

  return {
    resendSeconds: remainingSeconds,
    resendBlocked: remainingSeconds > 0,
    startResendCooldown: start,
    resetResendCooldown: reset,
  };
};

export default useOtpResendCooldown;
